import React from 'react';
import PropTypes from 'prop-types';

class AzureMap extends React.Component {
    constructor(props) {
        super(props);
        this.mapRef = React.createRef();
        this.mapInstance = null;
        this.mapId = props.mapId || `azuremap-${Math.random().toString(36).substr(2, 9)}`;        
    }

    componentDidMount() {
        this.loadMap();
    }

    componentWillUnmount() {
        if (this.mapInstance) {
            this.mapInstance.dispose();
        }
    }

    loadMap = () => {
        const {
            latitude,
            longitude,
            zoom = 10,
            azureMapsKey 
        } = this.props;

        if (window.atlas && this.mapRef.current) {
            this.mapInstance = new window.atlas.Map(this.mapRef.current, {
                center: [parseFloat(longitude), parseFloat(latitude)],
                zoom: parseInt(zoom),
                authOptions: {
                    authType: 'subscriptionKey',
                    subscriptionKey: azureMapsKey 
                }
            });

            this.mapInstance.events.add('ready', () => {
                const marker = new window.atlas.HtmlMarker({
                    position: [parseFloat(longitude), parseFloat(latitude)]
                });
                this.mapInstance.markers.add(marker);
            });
        }
    };

    render() {
        const { width, height } = this.props;
        return (
            <div
                ref={this.mapRef}
                style={{
                    width: typeof width === 'number' ? `${width}px` : width,
                    height: typeof height === 'number' ? `${height}px` : height
                }}
            />
        );
    }
}

AzureMap.propTypes = {
    latitude: PropTypes.string.isRequired,
    longitude: PropTypes.string.isRequired,
    azureMapsKey: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    zoom: PropTypes.number
};

export default AzureMap;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Meeting/components/AzureMap.js